import { DividaResource } from '@/models/resources';

class SyncDuracaoDividaTracker {
  private inicioMs: number | null = null;

  private readonly chegadasMs = new Map<string, number>();

  private static calcularKey(api: string, id: number): string {
    return `${api}-${id}`;
  }

  iniciar(inicioMs: number): void {
    this.inicioMs = inicioMs;
  }

  registrarChegada(dividas: DividaResource[], chegadaMs = Date.now()): void {
    dividas.forEach((divida) => {
      const key = SyncDuracaoDividaTracker.calcularKey(divida.api, divida.id);
      if (!this.chegadasMs.has(key)) {
        this.chegadasMs.set(key, chegadaMs);
      }
    });
  }

  obterDuracaoMs(api: string, id: number): number | undefined {
    if (this.inicioMs === null) {
      return undefined;
    }
    const chegadaMs = this.chegadasMs.get(SyncDuracaoDividaTracker.calcularKey(api, id));
    if (chegadaMs === undefined) {
      return undefined;
    }
    return chegadaMs - this.inicioMs;
  }

  reset(): void {
    this.inicioMs = null;
    this.chegadasMs.clear();
  }
}

const syncDuracaoDividaTracker = new SyncDuracaoDividaTracker();

export default syncDuracaoDividaTracker;
